export default __webpack_public_path__ + "static/media/element_1.c1b536f1.webp";